import { render, staticRenderFns } from "./intelligentBodyChat.vue?vue&type=template&id=c9867ac2&scoped=true"
import script from "./intelligentBodyChat.vue?vue&type=script&lang=js"
export * from "./intelligentBodyChat.vue?vue&type=script&lang=js"
import style0 from "./intelligentBodyChat.vue?vue&type=style&index=0&id=c9867ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9867ac2",
  null
  
)

export default component.exports